import { effect, inject, Injectable } from '@angular/core';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class KeycloakEventLoggerService {
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

  constructor() {
    console.log('KeycloakEventLoggerService initialized');
    this.subscribeToKeycloakEvents();
  }

  private subscribeToKeycloakEvents() {
    effect(() => {
      const keycloakEvent = this.keycloakSignal();
      switch (keycloakEvent.type) {
        case KeycloakEventType.AuthSuccess:
          console.log('Authentifizierung erfolgreich');
          break;
        case KeycloakEventType.AuthError:
          console.log('Authentifizierungsfehler');
          break;
        case KeycloakEventType.AuthRefreshSuccess:
          console.log('Token-Aktualisierung erfolgreich');
          break;
        case KeycloakEventType.AuthRefreshError:
          console.log('Token-Aktualisierungsfehler');
          break;
        case KeycloakEventType.AuthLogout:
          console.log('Benutzer ausgeloggt');
          break;
        case KeycloakEventType.TokenExpired:
          console.log('Token abgelaufen');
          break;
        case KeycloakEventType.Ready:
          console.log('Keycloak bereit');
          break;
      }
      console.log('Keycloak-Ereignis:', keycloakEvent.type);
    });
  }
}
